import { Box, Stack, Dialog, Button, useTheme, IconButton, Typography } from '@mui/material';

import StarIcon from 'src/assets/icons/star-icon';
import PizzaIcon from 'src/assets/icons/pizza-icon';
import MiniBookIcon from 'src/assets/icons/mini-book-icon';
import BookHearthIcon from 'src/assets/icons/book-hearth-icon';

import Iconify from '../iconify';

interface MyInterestsInviteDialogProps {
  open: boolean;
  onClose: () => void;
  onRespond: () => void;
}

export default function MyInterestsInviteDialog({
  open,
  onClose,
  onRespond,
}: MyInterestsInviteDialogProps) {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          bgcolor: theme.palette.yellowBrand[0],
          p: 12,
          position: 'relative',
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 16,
          color: theme.palette.blueBrand[400],
        }}
      >
        <Iconify icon="mdi:close" width={24} />
      </IconButton>

      <Stack spacing={8} alignItems="flex-start">
        <Stack direction="row" spacing={6} alignItems="center">
          <BookHearthIcon />
          <Typography variant="h3" color={theme.palette.blueBrand[400]} mt={2}>
            RESPONDA AO QUIZ
          </Typography>
        </Stack>

        <Typography variant="paragraphM500" color={theme.palette.blueBrand[500]}>
          Veja o que mais te interessa primeiro! Responda ao Quizz para ter uma experiência mais
          personalizada.
        </Typography>

        <Stack spacing={6}>
          <Stack direction="row" spacing={6} alignItems="flex-start">
            <Box sx={{ justifyContent: 'center', mt: 4 }}>
              <PizzaIcon />
            </Box>
            <Typography variant="paragraphP500" color={theme.palette.blueBrand[500]}>
              Receba sugestões de acordo com as suas preferências.
            </Typography>
          </Stack>

          <Stack direction="row" spacing={6} alignItems="flex-start">
            <Box sx={{ justifyContent: 'center', mt: 4 }}>
              <StarIcon />
            </Box>
            <Typography variant="paragraphP500" color={theme.palette.blueBrand[500]}>
              Responda as perguntas do nosso Quizz para te conhecermos melhor!
            </Typography>
          </Stack>

          <Stack direction="row" spacing={6} alignItems="flex-start">
            <Box sx={{ justifyContent: 'center', mt: 4 }}>
              <MiniBookIcon />
            </Box>
            <Typography variant="paragraphP500" color={theme.palette.blueBrand[500]}>
              Sua tela inicial será personalizada com o que você mais gosta.
            </Typography>
          </Stack>
        </Stack>

        <Stack direction="row" spacing={2} width="100%" mt={2}>
          <Button
            variant="contained"
            onClick={onRespond}
            sx={{
              bgcolor: theme.palette.blueBrand[400],
              color: theme.palette.common.white,
            }}
          >
            Responder
          </Button>

          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              borderColor: theme.palette.blueBrand[400],
              color: theme.palette.blueBrand[400],
            }}
          >
            Talvez mais tarde
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
